import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';
import { Bookmark, BookmarkBorder } from '@mui/icons-material';
import { IconButton } from '@mui/material';

const SaveCheckbox = ({ active, setActive, fontSize, margin, color }) => {
    return (
        <Container fontSize={fontSize} margin={margin} color={color}>
            <IconButton aria-label="toggle password visibility" onClick={() => setActive(!active)}>
                {active ? <Bookmark /> : <BookmarkBorder />}
            </IconButton>
        </Container>
    );
};

SaveCheckbox.propTypes = {
    active: PropTypes.bool,
    setActive: PropTypes.func.isRequired,
    fontSize: PropTypes.string,
    margin: PropTypes.string,
    color: PropTypes.string
};

export default SaveCheckbox;
